import { BASE_PATH } from "@/lib/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import globalAxios from "axios"

export const useRetryProvisioning = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (councilCode: string) => {
      const response = await globalAxios.post<{ data: string }>(
        `${BASE_PATH}/api/admin/waterbureaus/provisioning/${encodeURIComponent(councilCode)}/retry`,
      )
      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["councils"] })
      queryClient.invalidateQueries({ queryKey: ["councils-list"] })
    },
  })
}
